import { render, staticRenderFns } from "./GraficaDona.vue?vue&type=template&id=2fa33179&scoped=true"
import script from "./GraficaDona.vue?vue&type=script&lang=js"
export * from "./GraficaDona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa33179",
  null
  
)

export default component.exports